// src/components/MyProfileModule.js
import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext'; // Para acceder a los datos del usuario logueado

// Recibe onLogout, navigateTo y currentView (del AppLayout)
function MyProfileModule() { // Ya no necesita isUserDropdownOpen, isEcommerceSubmenuOpen
  const { user, token } = useAuth(); // Obtiene el usuario y el token del contexto

  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  // const [username, setUsername] = useState(''); // ELIMINADO: No se usa
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  // Las funciones de toggle y getMenuItemClasses/getSubMenuItemClasses ya no son necesarias aquí, las maneja AppLayout
  // const toggleUserDropdown = () => {};
  // const toggleEcommerceSubmenu = () => {};
  // const getMenuItemClasses = (viewName) => { /* ... */ };
  // const getSubMenuItemClasses = (viewName) => { /* ... */ };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setMessage('');

    if (newPassword !== confirmNewPassword) {
      setMessage('Error: La nueva contraseña y la confirmación no coinciden.');
      return;
    }
    if (newPassword.length < 6) { // Ejemplo de validación
      setMessage('Error: La nueva contraseña debe tener al menos 6 caracteres.');
      return;
    }
    if (!currentPassword || !newPassword || !user?.user || !user?.email) {
        setMessage('Error: Todos los campos son obligatorios.');
        return;
    }
    if (!token) {
        setMessage('Error: No hay token de autenticación. Por favor, inicia sesión de nuevo.');
        return;
    }

    try {
      // CORRECCIÓN: Usar ruta relativa para la API
      const response = await fetch(`/api/users/${user.id}/password`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}` // Envía el token
        },
        body: JSON.stringify({
          currentPassword: currentPassword,
          newPassword: newPassword,
          user: user.user, // Enviar el nombre de usuario para verificación
          email: user.email // Enviar el email para verificación
        }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage('Contraseña actualizada exitosamente.');
        setCurrentPassword('');
        setNewPassword('');
        setConfirmNewPassword('');
      } else {
        setMessage(`Error: ${data.mensaje || 'Error al cambiar contraseña.'}`);
      }
    } catch (err) {
      console.error('Error de red al cambiar contraseña:', err);
      setMessage('Error de conexión con el servidor.');
    }
  };

  const handleUpdateProfile = async (e) => {
    e.preventDefault();
    setMessage('');

    // CORRECCIÓN: Usar user.user y user.email directamente del contexto si no se están editando
    if (!user?.user || !email.trim()) { // Si el email se edita, se usa el estado local
      setMessage('Error: Usuario y email no pueden estar vacíos.');
      return;
    }
    if (!token) {
      setMessage('Error: No hay token de autenticación. Por favor, inicia sesión de nuevo.');
      return;
    }

    try {
      // CORRECCIÓN: Usar ruta relativa para la API
      const response = await fetch(`/api/users/${user.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}` // Envía el token
        },
        body: JSON.stringify({
          nombre: user.nombre, // Mantener el nombre actual o permitir edición
          email: email, // Usar el estado local del email
          rol: user.rol // Mantener el rol actual
        }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage('Perfil actualizado exitosamente.');
        // Opcional: Actualizar el usuario en el contexto de autenticación si cambia el email/nombre
        // Esto requeriría una función 'updateUser' en AuthContext
      } else {
        setMessage(`Error: ${data.mensaje || 'Error al actualizar perfil.'}`);
      }
    } catch (err) {
      console.error('Error de red al actualizar perfil:', err);
      setMessage('Error de conexión con el servidor.');
    }
  };


  return (
    <> {/* Fragmento para agrupar elementos sin un div extra */}
      <h2 className="text-2xl font-bold text-gray-800 mb-6">Mi Cuenta y Perfil</h2>

      <div className="bg-white p-6 rounded-lg shadow mb-6">
        <h3 className="text-xl font-semibold text-gray-800 mb-4">Información del Perfil</h3>
        <form onSubmit={handleUpdateProfile}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label htmlFor="profileUsername" className="block text-gray-700 text-sm font-bold mb-2">Usuario</label>
              <input
                type="text"
                id="profileUsername"
                className="shadow appearance-none border rounded-lg w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline bg-gray-100 cursor-not-allowed"
                value={user?.user || ''}
                disabled // El nombre de usuario no se puede cambiar
              />
            </div>
            <div>
              <label htmlFor="profileName" className="block text-gray-700 text-sm font-bold mb-2">Nombre Completo</label>
              <input
                type="text"
                id="profileName"
                className="shadow appearance-none border rounded-lg w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline bg-gray-100 cursor-not-allowed"
                value={user?.nombre || ''}
                disabled // El nombre completo no se puede cambiar directamente aquí
              />
            </div>
            <div>
              <label htmlFor="profileEmail" className="block text-gray-700 text-sm font-bold mb-2">Correo Electrónico</label>
              <input
                type="email"
                id="profileEmail"
                className="shadow appearance-none border rounded-lg w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                value={email || user?.email || ''} // Si email local está vacío, usa el del user
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div>
              <label htmlFor="profileRole" className="block text-gray-700 text-sm font-bold mb-2">Rol</label>
              <input
                type="text"
                id="profileRole"
                className="shadow appearance-none border rounded-lg w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline bg-gray-100 cursor-not-allowed"
                value={user?.rol || ''}
                disabled // El rol no se puede cambiar desde aquí
              />
            </div>
          </div>
          <div className="pt-4">
            <button
              type="submit"
              className="w-full md:w-auto px-8 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white font-semibold rounded-lg shadow-md hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition duration-200 transform hover:scale-105"
            >
              <div className="flex items-center justify-center space-x-2">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m0 0H5"></path>
                </svg>
                <span>Actualizar Perfil</span>
              </div>
            </button>
          </div>
        </form>
      </div>

      <div className="bg-white p-6 rounded-lg shadow">
        <h3 className="text-xl font-semibold text-gray-800 mb-4">Cambiar Contraseña</h3>
        <form onSubmit={handleChangePassword}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label htmlFor="currentPassword" className="block text-gray-700 text-sm font-bold mb-2">Contraseña Actual</label>
              <input
                type="password"
                id="currentPassword"
                className="shadow appearance-none border rounded-lg w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                required
              />
            </div>
            <div>
              <label htmlFor="newPassword" className="block text-gray-700 text-sm font-bold mb-2">Nueva Contraseña</label>
              <input
                type="password"
                id="newPassword"
                className="shadow appearance-none border rounded-lg w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
            </div>
            <div>
              <label htmlFor="confirmNewPassword" className="block text-gray-700 text-sm font-bold mb-2">Confirmar Nueva Contraseña</label>
              <input
                type="password"
                id="confirmNewPassword"
                className="shadow appearance-none border rounded-lg w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                value={confirmNewPassword}
                onChange={(e) => setConfirmNewPassword(e.target.value)}
                required
              />
            </div>
          </div>
          {message && (
            <div className={`mt-4 p-3 rounded-lg flex items-center justify-center space-x-2 ${
              message.includes('Error')
                ? 'bg-red-100 text-red-700 border border-red-200'
                : 'bg-green-100 text-green-700 border border-green-200'
            }`}>
              {message.includes('Error') ? (
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
              ) : (
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
              )}
              <span className="font-medium">{message}</span>
            </div>
          )}

          {/* Botón de acción mejorado */}
          <div className="pt-4">
            <button
              type="submit"
              className="w-full md:w-auto px-8 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white font-semibold rounded-lg shadow-md hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition duration-200 transform hover:scale-105"
            >
              <div className="flex items-center justify-center space-x-2">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m0 0H5"></path>
                </svg>
                <span>Cambiar Contraseña</span>
              </div>
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default MyProfileModule;
